export const headerData = {
  name: "Virinchi Manepalli",
  title: "Hello! I am",
  desciption:
    "Frontend developer having two plus years of experience in helping startup's to grow.I like to tackle problems and solve them in the best Javascripty way.",
  image: "https://i.ibb.co/Vv8JRFq/virinchi-dp.jpg",
  resumePdf:
    "https://drive.google.com/file/d/1PK8nwQra6yu3FcT4DooT_QaK_7Rs2TaX/view",
};
